import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import {getImage } from '../../utils/helper'
import SingEvent from '../../assets/img/sing-event.png'
import SoldOutImg from '../../assets/img/sold-out.png'
import { EMPTY_ARRAY, EMPTY_OBJECT, EVENT_LOG_TITLE, EVENT_TYPES } from '../../constants/globalConstants'
import { getEventDetails,updateEventState,getPassDetails } from '../../redux/actions/eventDetailsActions'
import Loader from '../../components/global/Loader'
import Event from '../../components/homeComponents/Event'
import Pass from '../../components/homeComponents/Pass'
import Header from '../../components/global/Header'
import Steps from '../../components/global/Steps'
import { getUserIp, storeEventLog } from '../../redux/actions/eventLogActions'
import getConfigDetails from '../../services/config'
import {PassEventAnalytics,SingleEventAnalytics} from '../../utils/GoogleAnalytics'
import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'



function Home(props) {
	const { dispatch, events, loader,passData } = props
	const [isLoading, setIsLoading] = useState(true)
	const [selectedId, setSelectedId] = useState()
	const [eventData , setEventData] = useState(events)
	const [eventshow , setEventshow] = useState(false)
	const [CardDetails, setCardDetails] = useState({})
	const [CardDetailsData, setCardDetailsData] = useState({})
	const [passshow , setPassshow] = useState(false)
	const [soldOut , setSoldOut] = useState(0)
	const [itemIndex , setitemIndex] = useState(0)
	const [isEventsLoading , setIsEventsLoading] = useState(false)
	const eventsData = events?.events?.data
	const eventListRef = useRef(null)

	const currentYear = new Date().getFullYear()

	useEffect(() => {
		setIsEventsLoading(loader)
	},[EMPTY_ARRAY, loader])
	useEffect(() => {
		
		window.scrollTo(0, 0)
		setSelectedId(1)
		localStorage.setItem('event_id',1) 
		localStorage.setItem('coupon','') 
		localStorage.setItem('promo_applied','') 
		localStorage.setItem('couponApplied','') 
		localStorage.setItem('couponFilled','') 
		localStorage.removeItem('isSubmitted')
		dispatch(getUserIp()).then((res) => {
			localStorage.setItem('user_ip', res.IPv4)
		}).catch((err) => {
			console.log(err)
		})

		const payload = {
			'error_message': 'Null',
			'facility_id': getConfigDetails.FACILITY_ID,
			'event_name': EVENT_LOG_TITLE?.HOME,
			'user_id': 0,
			'user_ip': localStorage.getItem('user_ip')
		}

	
		dispatch(storeEventLog(payload))

		/**get pass***/
		const passPayloads = {
			facility_id: getConfigDetails.FACILITY_ID
		}

		dispatch(getPassDetails(passPayloads)).then((res) => {
			setEventData({passData : res?.data})
			setPassshow(true)

			const eventpayload = {
				event_type: EVENT_TYPES?.EVENT,
				facility_id: getConfigDetails.FACILITY_ID,
			}

			dispatch(getEventDetails(eventpayload)).then((res) => {
			
				setIsLoading(false)
				localStorage.setItem('event_type', EVENT_TYPES?.EVENT)
				setEventData({eventData : res?.data})
				dispatch(updateEventState({ event_type: EVENT_TYPES?.EVENT }))
				setEventshow(true)
				
			})
		})
		
			
	}, [EMPTY_ARRAY])

	const ClickPassEventAnalytics = (data) => {
		PassEventAnalytics(data)
		
	}
	const ClickSingleEventAnalytics = (data) => {
		SingleEventAnalytics(data)		
	}

	const handleSelect=(e) =>{
		// console.log('indexs comimg')
		// let indexs = e.item.index 
		// console.log('indexs',e,indexs)
		//let startPosition = e.item.index - e.page.size
		// console.log('indexs startPosition',startPosition)
		//setitemIndex(startPosition)
		setitemIndex(e.item.index )
	}

	

	const responsiveCarousal = {
		margin: 10,
		loop:false,
		responsiveClass: true,
		nav: true,
		dots: false,
		navText : ["<i class='fa-solid fa-3x fa-angle-left'></i>","<i class='fa-solid fa-3x  fa-angle-right'></i>"],

		// autoplay: true,
		// autoplayTimeout:2000,
		//navText: ['Prev', 'Next'],
		//smartSpeed: 1000,
		responsive: {
			0: {
				items: 1,
			},
			400: {
				items: 1,
			},
			600: {
				items: 2,
			},
			700: {
				items: 3,
			},
			1000: {
				items: 4,
	
			}
		},
	}
	const getCard = (passesSoldOut,event_type,pass_id,card) => {
		setSoldOut(soldOut)
		if(passesSoldOut == 0){
			setSelectedId(pass_id)
			window.scrollTo(0, eventListRef.current.offsetTop) 
			// setIsLoading(true)
			setEventshow(false)	
			setCardDetails(card)
			setCardDetailsData(card.details)

			localStorage.setItem('event_type',event_type) 
			localStorage.setItem('event_id',pass_id) 
			dispatch(updateEventState({ event_type: event_type }))
			const eventpayloads = {
				event_type: event_type,
				facility_id: getConfigDetails.FACILITY_ID,
				pass_id: pass_id,
			}
			dispatch(getEventDetails(eventpayloads)).then((res) => {
				setEventData({eventData : res?.data})
				setIsLoading(false)
				
			}) 
			const PassEventAnalyticsPayloads = {
				event_type: event_type,
				facility_id: getConfigDetails.FACILITY_ID,
				pass_id: pass_id,
				card_data:card
			}
			ClickPassEventAnalytics(PassEventAnalyticsPayloads)
		}
	}

	const getEventCard = (event_type) => {         
		setSelectedId(1)
		window.scrollTo(0, eventListRef.current.offsetTop) 
		// setIsLoading(true)
		localStorage.setItem('event_type',event_type) 
		localStorage.setItem('event_id',1) 

		dispatch(updateEventState({ event_type: event_type }))
		const eventpayloads = {
			event_type: event_type,
			facility_id: getConfigDetails.FACILITY_ID,
		}
		dispatch(getEventDetails(eventpayloads)).then((res) => {
			setEventData({eventData : res?.data})
			setEventshow(true)
			setIsLoading(false)
			
		}) 
		const SingleEventAnalyticsPayloads = {
			event_type: event_type,
			facility_id: getConfigDetails.FACILITY_ID
		}
		ClickSingleEventAnalytics(SingleEventAnalyticsPayloads)
	}

	
	return (
		isLoading ? <Loader/> : <div>
			<Header/>

			<main>
				<Steps
					page='home'
				/>
				<div className="container px-5 px-sm-0  ">
					<div className="row g-5 my-4 mb-2 passList justify-content-md-center">
					<div  className="col-sm-10 col-md-9">
                    <OwlCarousel className="slider-items owl-carousel owl-theme" startPosition={itemIndex} onChanged={handleSelect} {...responsiveCarousal}  >			
					<div className="item p-3  text-center">
						<article className={selectedId==1 ? 'active' : ''}  onClick={() => getEventCard(EVENT_TYPES?.EVENT)} >
						<div className='img-wrap shadow d-flex flex-column justify-content-center'><img src={SingEvent} alt="SingleEvent" className="w-100" /></div>
						<h4>Single Event</h4></article>
						</div>
				{passshow ? passData?.map((pass, key) => {
											
						return (
							<><div key={key}  className="item  p-3 text-center">
								
								<article className={selectedId==pass.id ? 'active' : ''}  onClick={() => getCard(pass?.is_pass_sold, pass.pass_type_slug,pass.id,pass)}>
								
								<div className='img-wrap shadow d-flex flex-column justify-content-center'>
								{pass?.is_pass_sold == 1 && <span className="sold-out"><img src={SoldOutImg}/></span>}
									<img src={getImage(pass)} className="w-100" alt="EventPass" /></div>
								<h4>{pass.description}</h4>
								</article></div></>
							
						)
						}) :''}
						
					
			</OwlCarousel>
					</div>
					</div>
					{(events?.event_type!=EVENT_TYPES?.EVENT && events.event_type!='' && eventsData)? (
						<div>
					<p className=' mx-auto text-center'  style={{maxWidth: '800px'}}>
											{CardDetailsData}
										</p>
										<hr/>
										</div>
					):null}
					</div>
				
				
				
				<div className="container" ref={eventListRef}>
					<h2 className="text-center mb-4">
				Blue Cross Arena Event Parking Schedule for {`${currentYear}-${Number(currentYear)+1}`} Season
					</h2>
					{isEventsLoading ? <Loader eventsLoader/> : 
					(eventshow && events?.event_type==EVENT_TYPES?.EVENT && events?.event_type!='' && eventsData)? (
						<Event
							eventData={eventData}
							event_type={events?.event_type}
						></Event>

						
					):(events?.event_type!=EVENT_TYPES?.EVENT && events?.event_type!='' && eventsData)? (
						<Pass
							soldOut={soldOut}
							eventData={eventsData}
							event_type={events?.event_type}
							passCard={CardDetails}
						></Pass>

						
					):''}
					
				</div>
			</main>
		</div>
	)
	
}

Home.propTypes = {
	dispatch: PropTypes.func,
	data: PropTypes.object,
	events: PropTypes.object,
	loader: PropTypes.bool,
	getCard: PropTypes.func,
	passData: EMPTY_ARRAY,
}

Home.defaulProps = {
	dispatch: noop,
	data: EMPTY_OBJECT,
	events: EMPTY_OBJECT,
	loader: PropTypes.bool,
	getCard: PropTypes.func,
	passData: EMPTY_ARRAY,
}

function mapStateToProps({ peymentReducer, eventDetailsReducer }) {
	return {
		data: peymentReducer,
		events: eventDetailsReducer,
		loader: eventDetailsReducer.loader,
		passData: eventDetailsReducer.passDetails.data,
	}
}
export default connect(mapStateToProps)(Home)
